import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';

const API_URL = process.env.REACT_APP_BACKEND_URL;

// Member "My List" — list of {kind, id} plus a toggle that persists server-side.
export function useSaved(enabled) {
  const [items, setItems] = useState([]);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!enabled || !token) return;
    axios.get(`${API_URL}/api/me/saved`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => setItems(r.data?.items || []))
      .catch(() => {});
  }, [enabled]);

  const isSaved = useCallback((kind, id) => items.some((i) => i.kind === kind && i.id === id), [items]);

  const toggle = useCallback(async (kind, id) => {
    const token = localStorage.getItem('token');
    if (!token) return;
    try {
      const r = await axios.post(`${API_URL}/api/me/saved`, { kind, id }, { headers: { Authorization: `Bearer ${token}` } });
      setItems(r.data?.items || []);
      toast.success(r.data?.saved ? 'Added to My List' : 'Removed from My List');
    } catch {
      toast.error('Could not update My List');
    }
  }, []);

  return { items, isSaved, toggle };
}
